import { Controller } from '@hotwired/stimulus';
import Leaflet from 'leaflet';
import markerUrl from '../../images/location-pin.png';

export default class extends Controller {
    connect() {
        const position = [this.element.dataset.lng, this.element.dataset.lat];

        const map = Leaflet.map(this.element, {
            center: position,
            zoom: 15,
            scrollWheelZoom: false,
        });

        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(map);

        Leaflet.marker(position, {
            icon: new (Leaflet.Icon.extend({
                options: {
                    iconSize: [32, 42],
                },
            }))({ iconUrl: markerUrl }),
        }).addTo(map);
    }
}
